import Aegis from '@tencent/aegis-web-sdk-v2';
import { getUserId } from '@/infrastructure/auth';

// const aegisEnable = window.ENV === Env.Prod;
const BUSI_CODE_OK = 0;

const newAegisGalileo = () => new Aegis({
  id: 'SDK-be343bf6f150fc77715b',
  hostUrl: { url: 'https://galileotelemetry.tencent.com/collect' },
  uid: getUserId(), // 用户唯一 ID（可选）
  plugin: {
    pv: true,               // pv收集器
    aid: true,              // aid收集器
    error: true,            // error收集器
    device: true,           // device收集器
    close: true,            // close收集器
    pagePerformance: true,  // pagePerformance收集器
    webVitals: true,        // webVitals收集器
    fId: true,              // fId指纹插件
    ie: true,               // ie兼容插件
    spa: true,              // spa 上报插件
    assetSpeed: true,       // 资源测速插件
    apiSpeed: true,         // api测速插件
    api: {
      apiDetail: true,
      // 业务错误码上报
      retCodeHandler: (data: any) => {
        let retCode;
        try {
          const resp = JSON.parse(data);
          retCode = resp?.code ?? resp?.retCode ?? resp?.ret_code ?? resp?.errcode ?? resp?.ret ?? resp?.retcode;
        } catch (e) {}
        return {
          isErr: retCode && retCode !== BUSI_CODE_OK,
          code: retCode,
        };
      },
    },
  },
});

export const initAegisGalileo = () => {
  if (!window.aegisGalileo) {
    window.aegisGalileo = newAegisGalileo();
  }
};

initAegisGalileo();
